<template>
  <div class="vue-modal fixed flex items-center justify-center min-h-screen inset-0 bg-gray-500 bg-opacity-75 transition-opacity z-50" v-on:click.self="onClose">
      <div class="vue-modal-container flex-col bg-white p-6 rounded-lg overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <component v-if="this.$props.content" v-bind:is="this.$props.content.component" v-bind:data="this.$props.content.data"></component>
      </div>
  </div>
</template>
<script>
    export default {
        props: {
            content: null,
        },
        data() {
            return {
                //
            };
        },
        mounted() {
            //
        },
        created() {
            //
        },
        destroyed() {
            //
        },
        computed: {
            //
        },
        methods: {
            onClose() {
                this.$emit('close-modal');
            },
        },
    };
</script>
